export default {
  sweetness: `sweetness: __type(name:"WineSweetness") {
    enumValues {
      name
      description
    }
  }`,
  discount_group: `discount_group: __type(name:"DiscountGroup") {
    enumValues {
      name
      description
    }
  }`,
  wine_type: `wine_type: __type(name:"WineType") {
    enumValues {
      name
      description
    }
  }`,
  winebody: `winebody: __type(name:"WineBody") {
    enumValues {
      name
      description
    }
  }`,
  varietal: `varietal: __type(name:"WineVarietal") {
    enumValues {
      name
      description
    }
  }`,
  series: `series: __type(name:"WineSeries") {
    enumValues {
      name
      description
    }
  }`,
  brand: `series: __type(name:"WineBrand") {
    enumValues {
      name
      description
    }
  }`,
  collections: `series: __type(name:"WineCollections") {
    enumValues {
      name
      description
    }
  }`,
  attributes: `series: __type(name:"WineAttributes") {
    enumValues {
      name
      description
    }
  }`,
  region: `series: __type(name:"WineRegion") {
    enumValues {
      name
      description
    }
  }`,
  bodyicon: `bodyicon: __type(name:"BodyIcon") {
    enumValues {
      name
      description
    }
  }`,
  sizeicon: `sizeicon: __type(name:"SizeIcon") {
    enumValues {
      name
      description
    }
  }`,
  typeicon: `typeicon: __type(name:"TypeIcon") {
    enumValues {
      name
      description
    }
  }`,
  varietalicon: `varietalicon: __type(name:"VarietalIcon") {
    enumValues {
      name
      description
    }
  }`,
  pos_modifier_category: `pos_modifier_category: __type(name:"POSModifierProductCategory") {
    enumValues {
      name
      description
    }
  }`,
  pos_food_category: `pos_food_category: __type(name:"POSFoodProductCategory") {
    enumValues {
      name
      description
    }
  }`,
  pos_product_category: `pos_product_category: __type(name:"POSProductCategory") {
    enumValues {
      name
      description
    }
  }`
}
